import type React from 'react';
import { cn } from '../../utils/cn.js';

interface WorkspacePageProps {
  /** A compact header row (title, status, actions); keep it to one line. */
  header?: React.ReactNode;
  /** The working area; it fills the rest of the viewport and scrolls inside its own panels. */
  children: React.ReactNode;
  className?: string;
}

/**
 * The full-height template for tools you work inside (workflow builder, code workbench, editors): the content fills the
 * viewport under the app header, so panels scroll on their own instead of the page. Lay the panels out with
 * `SplitPane` / `ThreeColumnWorkspace`. Never hard-code `calc(100vh - …)` — the shell provides `--page-height`.
 */
export function WorkspacePage({ header, children, className }: WorkspacePageProps) {
  return (
    <div className={cn('flex flex-col gap-4 lg:h-(--page-height)', className)}>
      {header && <div className="flex shrink-0 flex-wrap items-center justify-between gap-3">{header}</div>}
      <div className="min-h-[560px] min-w-0 flex-1 lg:min-h-0">{children}</div>
    </div>
  );
}
